module.exports = __webpack_public_path__ + "img/sala.3554178c.png";